import { httpService } from "./httpService";

/**
 * Fetches tenant branding configuration (public endpoint, no auth required).
 * @returns {Promise<import("types/commonTypes").HttpResult<{companyName: string, primaryColor: string, secondaryColor: string, logoUrl: string}>>}
 */
export const getTenantBranding = async () =>
  httpService({
    url: "/tenant/branding",
    options: {
      method: "GET",
    },
  });

/** Re-issue the admin-email verification link + resend the email to the current admin. */
export const resendVerificationEmail = async () =>
  httpService({ url: "/tenants/resend-verification", options: { method: "POST" } });

/**
 * Fetches full tenant settings (SUPER_ADMIN / CUSTOMER_ADMIN only).
 */
export const getTenantSettings = async () =>
  httpService({
    url: "/tenant/settings",
    options: {
      method: "GET",
    },
  });

/**
 * Updates tenant branding (SUPER_ADMIN / CUSTOMER_ADMIN only).
 * @param {{companyName?: string, primaryColor?: string, secondaryColor?: string, logoUrl?: string}} payload
 */
export const updateTenantBranding = async (payload) =>
  httpService({
    url: "/tenant/settings/branding",
    options: {
      method: "PUT",
      data: payload,
    },
  });

/**
 * Fetches current plan and usage stats (SUPER_ADMIN / CUSTOMER_ADMIN only).
 */
export const getTenantPlan = async () =>
  httpService({
    url: "/tenant/settings/plan",
    options: {
      method: "GET",
    },
  });
